const lang = {
  contact: 'Contact',
  born: 'Né en',
  bornIn: 'à',
  experience: 'Expérience professionelle',
  education: 'Formation',
  skills: 'Compétences',
  about: 'À propos de moi'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/fr.js